import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

type Role = {
  id: string;
  name: string;
};

type TenantRoleIndexResponse = Role[];

export const tenantRoleApiClient = {
  index: async (): Promise<ApiResult<TenantRoleIndexResponse>> => {
    return await axiosClient.get('/tenant/tenant-roles');
  },
};
